import { render, staticRenderFns } from "./FeedbackListComponent.vue?vue&type=template&id=8b2d4594&scoped=true&"
import script from "./FeedbackListComponent.vue?vue&type=script&lang=ts&"
export * from "./FeedbackListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackListComponent.vue?vue&type=style&index=0&id=8b2d4594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2d4594",
  null
  
)

export default component.exports